export const ALL = 'all'
export const DRAFT = 'draft'
export const NOT_PAID = 'not_paid'
export const PARTIALLY_PAID = 'partially_paid'
export const PAID = 'paid'
export const HAS_COLLECTOR_STATUS = 'has_collector_status'
export const APPROVED = 'approved'
